export default __webpack_public_path__ + "static/media/bed.c1a97fa9.jpg";